import { computed, ref } from 'vue';
import { emitter } from '@phoenix/event-bus';
import {
  watchComparatorLocalStorageHelper,
  WATCH_COMPARATOR_UPDATED,
} from '@maison/helpers/watch-comparator-localstorage-helper';

export const MAX_WATCHES = 4;

const watches = ref(watchComparatorLocalStorageHelper.get());

const save = (nextWatches, added = null) => {
  watchComparatorLocalStorageHelper.save(nextWatches);
  watches.value = nextWatches;
  emitter.emit(WATCH_COMPARATOR_UPDATED, { watches: nextWatches, added });
};

const refresh = () => {
  watches.value = watchComparatorLocalStorageHelper.get();
};

emitter.on(WATCH_COMPARATOR_UPDATED, (payload) => {
  if (payload?.watches) {
    watches.value = payload.watches;
  } else {
    refresh();
  }
});

export const useWatchComparator = () => {
  const count = computed(() => watches.value.length);
  const isEmpty = computed(() => count.value === 0);
  const isFull = computed(() => count.value >= MAX_WATCHES);

  const isInWatchComparator = (reference) => watches.value.some((w) => w.reference === reference);

  const add = (watch) => {
    if (isInWatchComparator(watch.reference)) {
      return true;
    }

    if (isFull.value) {
      return false;
    }

    save([...watches.value, watch], watch);

    return true;
  };

  const remove = (reference) => {
    save(watches.value.filter((watch) => watch.reference !== reference));
  };

  const toggle = (watch) => {
    if (isInWatchComparator(watch.reference)) {
      remove(watch.reference);
      return true;
    }

    return add(watch);
  };

  return { watches, count, isEmpty, isFull, isInWatchComparator, add, remove, toggle, refresh, MAX_WATCHES };
};
